import {
  Button,
  DateBox,
  LoadPanel,
  TabPanel,
  TextBox,
} from "devextreme-react";
import SelectBox, { FieldAddons } from "devextreme-react/select-box";
import { Item } from "devextreme-react/tab-panel";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  getDetailTicketByTcode,
  getTicketDevelopers,
  getTicketTimeAnalysis,
  saveTicketActivity,
} from "../../../api/ticketApi";
import { getAllStatus } from "../../../api/settingsApi";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CustomDrawer from "../../../components/customDrawer/CustomDrawer";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import CustomPageHeader from "../../../components/customPageHeader/CustomPageHeader";
import NotesDrawer from "../../../components/notesDrawer/NotesDrawer";
import NotificationMain from "../../../components/notificationDrawer/notification-main";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import {
  HeaderText,
  MidLightText,
  SmallLightText,
  SubText,
} from "../../../components/typographyText/TypographyText";
import { useAuth } from "../../../contexts/auth";
import { statusDataSource2 } from "../data";
import "../detailTicketPage/DetailTicketPage.scss";
import ActivityPanel from "./activityPanel/ActivityPanel";
import NotesPanel from "./notesPanel/NotesPanel";
import QueryPanel from "./queryPanel/QueryPanel";
import TimeSpentPanel from "./timeSpentPanel/TimeSpentPanel";
import { getStatusApi } from "../../../api/ticketApi";
import { getPriorityApi } from "../../../api/settingsApi";
import { span } from "framer-motion/client";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";
import CustomButton from "../../../components/customButton/CustomButton";
import { getTicketTypes } from "../../../api/typeOfQueryTicket";
export const statusColors = {
  open: "#0f9a42",
  closed: "#525658",
  resolved: "#525658",
  "not possible": "#DC2626",
  "in progress": "#228dd5",
  "client approval": "#ee8608",
  pending: "#f59e0b",
};
export default function DetailTicketPage({}) {
  const location = useLocation();
  const { detailData } = location.state || {};
  const { user } = useAuth();
  const navigate = useNavigate();
  const isTicketClosed =
    detailData?.ticketstatus_name?.toLowerCase() === "closed";
  const [loading, setLoading] = useState();
  const [status, setStatus] = useState();
  const [selectedTab, setSelectedTab] = useState(0);
  const [detailTicketData, setDetailTicketData] = useState();
  const [ticketAnalysis, setTicketAnalysis] = useState();
  const [statusList, setStatusList] = useState([]);
  const [allStatusList, setAllStatusList] = useState([]);
  const [priority, setPriority] = useState();
  const [priorityList, setPriorityList] = useState([]);
  const isMobile = window.innerWidth < 768;
  const [showProperties, setShowProperties] = useState(!isMobile); // default open
  const [showTimeline, setShowTimeline] = useState(false);
  const [developerList, setDeveloperList] = useState([]);
  const [ticketTypeList, setTicketTypeList] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  // const [developers, setDevelopers] = useState([]);
  const [selectedDeveloper, setSelectedDeveloper] = useState(null);
  const [checkAssignedDev, setCheckAssignedDev] = useState(null);
  const [ticketQueryType, setTicketQueryType] = useState(null);
  const isCompany = user?.userrole === "company";
  const isCompanyUser = user?.userrole === "companyuser";
  const showCustomerSelect = isCompany || isCompanyUser;
  //Label Formatter for Ticket Time Analysis
  const formatLabel = (key) => {
    const customLabels = {
      ticket_created_datetime: "Creation Date and Time",
      developer_resolved_datetime: "Resolution Date and Time",
      ticket_closed_datetime: "Closed Date and Time",
      ticket_open_to_close_duration: "Total Closure Duration",
      total_developer_working_duration: "Total Working duration",
    };

    return (
      customLabels[key] ||
      key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    );
  };

  const isDevNotAssigned = !selectedDeveloper;

  const fetchDevelopers = async () => {
    const res = await getTicketDevelopers(detailData?.ticketcode);

    if (res.success) {
      setDeveloperList(res.data.developers);
    }
  };
  const fetchTicketTypes = async () => {
    const res = await getTicketTypes();

    if (res.success) {
      setTicketTypeList(res.data);
    }
  };

  const getTicketDetails = async () => {
    try {
      setLoading(true);
      const result = await getDetailTicketByTcode(detailData.ticketcode);
      setDetailTicketData(result.data);
      const devId =
        result?.ticket?.assigned_developer?.developer_id ??
        selectedDeveloper ??
        null;

      setSelectedDeveloper(devId);
      setCheckAssignedDev(devId);
      // setSelectedDeveloper(result?.ticket?.assigned_developer?.developer_id);
      // setCheckAssignedDev(result?.ticket?.assigned_developer?.developer_id);
    } catch (error) {
      ToastDisplayer("error", error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchPriorityList = async () => {
    try {
      const res = await getPriorityApi();

      const formatted = res.map((item) => ({
        text: item.name,
        value: item.id,
        color: priorityColors[item.name.toLowerCase()] || "#999",
      }));

      setPriorityList(formatted);
    } catch (error) {
      // console.log("Priority API error:", error);
    }
  };

  const fetchTicketTimeAnalysisData = async () => {
    try {
      if (!detailData?.ticketcode) return;

      const res = await getTicketTimeAnalysis(detailData.ticketcode);
      setTicketAnalysis(res?.data);
    } catch (error) {
      console.error("Error fetching ticket time analysis:", error);
    }
  };

  useEffect(() => {
    // fetchStatusList();
    if (showCustomerSelect) {
      fetchDevelopers();
    }
    fetchTicketTypes();
    fetchPriorityList();
    if (isTicketClosed) {
      fetchTicketTimeAnalysisData();
    }
  }, []);

  const priorityColors = {
    low: "#f0be09",
    medium: "#2f6bd8",
    high: "#d93025",
    important: "#F97316",
    urgent: "#DC2626",
  };

  const renderStatusItem = (data) => {
    if (!data) return <span>Select Status</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: data.color,
            display: "inline-block",
          }}
        />

        <span>{data.text}</span>
      </div>
    );
  };

  const renderDropDownButton = () => {
    const selected = statusList.find((s) => s.value === status);

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <span
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: selected?.color || "#ccc",
          }}
        />
        <i className="dx-icon dx-icon-chevron-down" />
      </div>
    );
  };

  const renderPriorityItem = (data) => {
    if (!data) return <span>Select Priority</span>;

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: data.color,
            display: "inline-block",
          }}
        />
        <span>{data.text}</span>
      </div>
    );
  };

  const fetchStatusList = async () => {
    try {
      const res = await getStatusApi();

      const formatted = res.map((item) => ({
        text: item.name,
        value: item.id,
        color: item.color_code,
      }));

      setStatusList(formatted);
    } catch (error) {
      // console.log("Status API error:", error);
    }
  };

  const fetchAllStatusList = async () => {
    try {
      const res = await getAllStatus();

      const formatted = res.map((item) => ({
        text: item.name,
        value: item.id.toString(),
        color: item.color_code,
      }));

      setAllStatusList(formatted);
    } catch (error) {
      console.error("Failed to fetch all status list", error);
    }
  };
  useEffect(() => {
    fetchStatusList(); // role-based
    fetchAllStatusList(); // for default display
  }, []);
  useEffect(() => {
    getTicketDetails();
  }, [detailData]);

  useEffect(() => {
    if (
      isInitialLoad &&
      detailTicketData?.ticket &&
      statusList.length > 0 &&
      allStatusList.length > 0 &&
      priorityList.length > 0
    ) {
      setStatus(detailTicketData.ticket.ticketstatus_fk);
      // setStatus(detailTicketData.ticket.ticketstatus_fk?.toString());
      setPriority(detailTicketData.ticket.ticketpriority_fk);
      setTicketQueryType(detailTicketData.ticket.tickettype);

      // ADD THIS
      setSelectedDeveloper(
        detailTicketData.ticket.assigned_developer?.developer_id,
      );
      setCheckAssignedDev(
        detailTicketData.ticket.assigned_developer?.developer_id,
      );
      setIsInitialLoad(false);
    }
  }, [
    detailTicketData,
    statusList,
    allStatusList,
    priorityList,
    isInitialLoad,
  ]);

  const onItemClick = (e) => {
    setSelectedTab(e.itemIndex);
  };

  const handleDetCancel = () => {};

  const handleDetSave = async () => {
    try {
      setLoading(true);

      let payload = {
        ticketcode: detailTicketData.ticket.ticketcode,
      };

      // send only if changed
      if (status !== detailTicketData.ticket.ticketstatus_fk) {
        payload.ticketstatus_fk = status;
      }

      if (priority !== detailTicketData.ticket.ticketpriority_fk) {
        payload.ticketpriority_fk = priority;
      }

      if (ticketQueryType !== detailTicketData.ticket.tickettype) {
        payload.tickettype = ticketQueryType;
      }

      if (
        selectedDeveloper !==
        detailTicketData.ticket.assigned_developer?.developer_id
      ) {
        payload.developer_id = selectedDeveloper;
      }

      if (user?.userrole === "companyuser") {
        payload.creatorcode = user?.cmpusercode;
      } else if (user?.userrole === "company") {
        payload.companytransid = user?.companytransid;
      } else if (user?.userrole === "customer") {
        payload.creatorcode = user?.customercode;
      }

      const result = await saveTicketActivity(payload);

      if (result.status === 200) {
        ToastDisplayer("success", result?.data?.message);
      }
    } catch (error) {
      if (error?.response) {
        ToastDisplayer("error", error?.response?.data?.error);
      } else if (error?.request) {
        ToastDisplayer(
          "error",
          "No response from server. Please check your internet connection.",
        );
      } else {
        ToastDisplayer("error", error?.message || "Something went wrong");
      }
    } finally {
      setLoading(false);
    }
  };

  const ticketTypeOptions = React.useMemo(() => {
    if (!ticketTypeList) return [];

    return ticketTypeList.map((item) => ({
      value: item.transid, // ✅ use ID
      text: item.tickettypename,
    }));
  }, [ticketTypeList]);

  const handleCancelButton = () => {};
  const isReadOnly = user?.userrole === "companyuser" && checkAssignedDev;
  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="detailTicPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span>
                <i class="ri-coupon-line"></i>
              </span>
              {/* <p>All Ticket</p> */}
              <BreadCrumb />{" "}
              <span style={{ color: "#344450", fontWeight: 500 }}>
                {" "}
                : {detailData?.ticketcode}
              </span>
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              icon="doc"
              text={"Properties"}
              height={"40px"}
              stylingMode="outlined"
              type="normal"
              onClick={() => setShowProperties((prev) => !prev)}
            />
            <Button
              icon="clock"
              text={"Timeline"}
              height={"40px"}
              stylingMode="outlined"
              type="normal"
              onClick={() => setShowTimeline((prev) => !prev)}
            />
          </div>
        </div>

        {/* <AddNewSubHeader
          titleName={"All Ticket"}
          handleSaveDetails={handleDetSave}
          handleCancel={handleCancelButton}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-edit-line"}
        /> */}
        <div className="detMainSec middlePart">
          <div className="detLeft">
            <div className="tab-panel">
              <TabPanel
                width={"100%"}
                height={"100%"}
                animationEnabled={false}
                swipeEnabled={false}
                tabsPosition={"top"}
                stylingMode={"primary"}
              >
                <Item title={"Query"}>
                  <QueryPanel
                    detailTicketData={detailTicketData}
                    getTicketDetails={getTicketDetails}
                    isTicketClosed={isTicketClosed}
                  />
                </Item>
                <Item title={"Notes"}>
                  <NotesPanel
                    detailTicketData={detailTicketData}
                    getTicketDetails={getTicketDetails}
                    isTicketClosed={isTicketClosed}
                  />
                </Item>
                <Item title={"Time Spent"}>
                  <TimeSpentPanel
                    detailTicketData={detailTicketData}
                    getTicketDetails={getTicketDetails}
                    isTicketClosed={isTicketClosed}
                  />
                </Item>
              </TabPanel>
            </div>
          </div>
          {showProperties && (
            <div className="detRight">
              <div className="detTabSec">
                <div className="drawerHeader">
                  <SubText text="Properties" />
                  <i
                    className="ri-close-line closeIcon"
                    onClick={() => setShowProperties(false)}
                  ></i>
                </div>
                <div className="detInnerCont">
                  <div className="detInner">
                    <SelectBox
                      width="100%"
                      label="Select Status"
                      items={statusList}
                      displayExpr="text"
                      valueExpr="value"
                      value={status}
                      stylingMode="outlined"
                      itemRender={renderStatusItem}
                      dropDownButtonRender={renderDropDownButton}
                      onValueChanged={(e) => setStatus(e.value)}
                      disabled={isTicketClosed || isDevNotAssigned}
                    />
                  </div>

                  <div className="detInner">
                    <SelectBox
                      label="Select Priority"
                      items={priorityList}
                      displayExpr="text"
                      valueExpr="value"
                      value={priority}
                      stylingMode="outlined"
                      itemRender={renderPriorityItem}
                      dropDownButtonRender={() => {
                        const selected = priorityList.find(
                          (p) => p.value === priority,
                        );

                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span
                              style={{
                                width: "16px",
                                height: "16px",
                                borderRadius: "50%",
                                backgroundColor: selected?.color || "#ccc",
                              }}
                            />
                            <i className="dx-icon dx-icon-chevron-down" />
                          </div>
                        );
                      }}
                      onValueChanged={(e) => {
                        setPriority(e.value);
                      }}
                      disabled={isTicketClosed || isDevNotAssigned}
                    />
                  </div>
                  {user?.userrole !== "customer" &&
                    user?.userrole !== "customercontact" && (
                      <div className="detInner">
                        <SelectBox
                          stylingMode="outlined"
                          label="Assign Developer"
                          searchEnabled
                          displayExpr={"username"}
                          valueExpr={"user_id"}
                          items={developerList}
                          value={selectedDeveloper}
                          onValueChanged={(e) => setSelectedDeveloper(e.value)}
                          readOnly={isReadOnly}
                          disabled={isTicketClosed}
                          onOpened={() => {
                            if (!developerList || developerList.length === 0) {
                              ToastDisplayer(
                                "error",
                                "First assign this project to developer",
                              );
                            }
                          }}
                        />
                      </div>
                    )}
                  <div className="detInner">
                    <SelectBox
                      stylingMode="outlined"
                      label="Type of Query"
                      searchEnabled
                      items={ticketTypeOptions}
                      displayExpr="text"
                      valueExpr="value"
                      value={ticketQueryType}
                      onValueChanged={(e) => setTicketQueryType(e.value)}
                      disabled={isTicketClosed || isDevNotAssigned}
                    />
                  </div>
                  <div
                    className="detInnerTxt"
                    style={{ display: "flex", gap: "8px" }}
                  >
                    <MidLightText text={"Current Status :"} />

                    {(() => {
                      const selected = allStatusList.find(
                        (s) =>
                          s.value ===
                          detailTicketData?.ticket?.ticketstatus_fk?.toString(),
                      );

                      return (
                        <>
                          <span
                            style={{
                              width: "10px",
                              height: "10px",
                              borderRadius: "50%",
                              backgroundColor: selected?.color || "#ccc",
                              marginTop: "6px",
                            }}
                          />
                          <SmallLightText text={selected?.text || "--"} />
                        </>
                      );
                    })()}
                  </div>
                  {user?.userrole !== "customer" &&
                    user?.userrole !== "customercontact" && (
                      <div className="detInnerTxt">
                        <MidLightText text={"Client :"} />
                        <SmallLightText
                          text={detailTicketData?.ticket?.customer_name}
                        />
                      </div>
                    )}
                  <div className="detInnerTxt">
                    <MidLightText text={"Project :"} />
                    <SmallLightText
                      text={detailTicketData?.ticket?.ticketcategoryname}
                    />
                  </div>
                  <div className="detInnerTxt">
                    <MidLightText text={"Category :"} />
                    <SmallLightText
                      text={detailTicketData?.ticket?.ticketsubcatname || "--"}
                    />
                  </div>
                  {!showCustomerSelect && (
                    <div className="detInnerTxt">
                      <MidLightText text={"Assigned Developer:"} />
                      <SmallLightText
                        text={
                          detailTicketData?.ticket?.assigned_developer
                            ?.developer_name || "--"
                        }
                      />
                    </div>
                  )}
                  <div className="detInnerTxt">
                    <MidLightText text={"Department :"} />
                    <SmallLightText
                      text={detailTicketData?.ticket?.departmentname || "--"}
                    />
                  </div>
                  <div className="detInnerTxt">
                    <MidLightText text={"On Behalf Of :"} />
                    <SmallLightText
                      text={detailTicketData?.ticket?.on_behalf_of || "--"}
                    />
                  </div>
                </div>
              </div>
              <div className="create-button" style={{ width: "100%" }}>
                <CustomButton
                  text={"Update"}
                  onClick={handleDetSave}
                  disabled={isTicketClosed}
                />
              </div>
            </div>
          )}
          {showTimeline && (
            <div className="detMid">
              <div className="timeline">
                <div className="drawerHeader">
                  {" "}
                  <SubText text="TimeLine" />
                  <i
                    className="ri-close-line closeIcon"
                    onClick={() => setShowTimeline(false)}
                  ></i>
                </div>
                <ActivityPanel activityData={detailTicketData?.activities} />
              </div>
            </div>
          )}
        </div>
        {isTicketClosed && ticketAnalysis && (
          <div className="ticket-analysis-section">
            <SubText text="Ticket Time Analysis" />

            <div className="analysis-grid">
              <div className="analysis-card">
                <div className="label">
                  {formatLabel("ticket_created_datetime")}
                </div>
                <div className="value">
                  {ticketAnalysis?.ticket_created_datetime ?? "N/A"}
                </div>
              </div>

              <div className="analysis-card">
                <div className="label">
                  {formatLabel("developer_resolved_datetime")}
                </div>
                <div className="value">
                  {ticketAnalysis?.developer_resolved_datetime ?? "N/A"}
                </div>
              </div>

              <div className="analysis-card">
                <div className="label">
                  {formatLabel("ticket_closed_datetime")}
                </div>
                <div className="value">
                  {ticketAnalysis?.ticket_closed_datetime ?? "N/A"}
                </div>
              </div>

              <div className="analysis-card highlight">
                <div className="label">
                  {formatLabel("ticket_open_to_close_duration")}
                </div>
                <div className="value">
                  {ticketAnalysis?.ticket_open_to_close_duration ?? "N/A"}
                </div>
              </div>

              <div className="analysis-card highlight">
                <div className="label">
                  {formatLabel("total_developer_working_duration")}
                </div>
                <div className="value">
                  {ticketAnalysis?.total_developer_working_duration ?? "N/A"}
                </div>
              </div>
            </div>
            {ticketAnalysis?.developer_working_details?.length > 0 && (
              <div className="developer-analysis-section">
                <SubText text="Developer Information" />

                <div className="analysis-grid">
                  {ticketAnalysis.developer_working_details.map(
                    (dev, index) => (
                      <div className="analysis-card" key={index}>
                        <div className="label">Developer Name</div>
                        <div className="value">
                          {dev?.developer_name ?? "N/A"}
                        </div>

                        <div className="label mt-8">Working Duration</div>
                        <div className="value highlight-text">
                          {dev?.total_duration ?? "N/A"}
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
}

///on_behalf_of
